import styles from './DateListed.less';

import React, { Component, PropTypes } from 'react';

import RefineRadio from 'RefineRadio/RefineRadio';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import { preventRenderingInClientIfNot } from 'prevent-rendering-if-not';
import { optimisticUpdateDateListedClicked } from 'store/search/optimistic/refinement';

export default class DateListed extends Component {

  static propTypes = {
    handleSelection: PropTypes.func.isRequired,
    dateRanges: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired
  };

  shouldComponentUpdate({ active }) {
    return active;
  }

  render() {
    const { handleSelection, dateRanges, active } = this.props;

    return (
      <nav role="navigation" className={styles.root}>
        <ScreenReaderOnly>
          <h1 id="RefineDateListed">Date Listed</h1>
        </ScreenReaderOnly>
        { preventRenderingInClientIfNot(active) ?
          <RefineRadio
            multiSelect={false}
            handleSelection={handleSelection}
            preNavigationAction={optimisticUpdateDateListedClicked}
            labelledBy="RefineDateListed"
            options={dateRanges}
            path="/jobs"
            data-automation="refineDateListed"
          /> : null }
      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/RefineBar/components/DateListed/DateListed.js
 **/